import React, { useState } from 'react';
import { MetaHead } from '../components/MetaHead';
import { GalleryModal } from '../components/GalleryModal';
import { SCRAPED_PAGES, COMPANY_INFO, COMMON_CONTACT_CALLOUT } from '../data/scrapedData';

export function SejstrupPage() {
  const p = SCRAPED_PAGES.sejstrup;
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [galleryIndex, setGalleryIndex] = useState(0);

  const imageAlts = [
    "Hvidmalet bygning med græsplæne og hegn i Sejstrup",
    "Solrig træterrasse med liggestole foran træhytte",
    "Madlavning ved et stort komfur i industrikøkkenet"
  ];

  return (
    <>
      <MetaHead title={p.title} description={p.metaDescription} />

      <section className="bg-[#1C1C1E] text-white py-14 sm:py-18">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs uppercase tracking-widest font-semibold text-[#3885B8] block mb-2">
            Boforhold i Sejstrup
          </span>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-white mb-3">
            {p.h1}
          </h1>
          <p className="text-base sm:text-lg text-white/90 max-w-3xl leading-relaxed">
            {p.intro}
          </p>
        </div>
      </section>

      <section className="py-16 bg-[#F8FAFC]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          
          {/* Photos */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {p.images.map((img, idx) => (
              <div
                key={idx}
                onClick={() => { setGalleryIndex(idx); setGalleryOpen(true); }}
                className="aspect-4/3 rounded-2xl overflow-hidden border border-[#1C1C1E]/10 shadow-xs cursor-pointer group relative"
              >
                <img
                  src={img}
                  alt={imageAlts[idx] || `Foto ${idx + 1}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white">
                  <i className="fa-solid fa-magnifying-glass-plus text-2xl" aria-hidden="true" />
                </div>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-2xl border border-[#1C1C1E]/10 shadow-xs space-y-4">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1C1C1E] tracking-tight mb-4 border-l-4 border-[#1C1C1E] pl-3">
                Fællesrum
              </h2>
              <ul className="space-y-2.5 text-sm text-[#1C1C1E]/80">
                {p.commonRooms.map((room, idx) => (
                  <li key={idx} className="flex items-center gap-2.5">
                    <i className="fa-solid fa-check text-[#3885B8]" aria-hidden="true" />
                    <span>{room}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-white p-8 rounded-2xl border border-[#1C1C1E]/10 shadow-xs space-y-4">
              <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1C1C1E] tracking-tight mb-4 border-l-4 border-[#1C1C1E] pl-3">
                Bo-afdelinger
              </h2>
              <ul className="space-y-2.5 text-sm text-[#1C1C1E]/80">
                {p.livingSections.map((sec, idx) => (
                  <li key={idx} className="flex items-start gap-2.5">
                    <i className="fa-solid fa-house-chimney text-[#1C1C1E] mt-0.5" aria-hidden="true" />
                    <span>{sec}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="bg-[#1C1C1E] text-white p-6 rounded-2xl text-center font-bold text-sm shadow-xs">
            <p>{p.highlightNote}</p>
            <p className="text-xs font-normal text-white/80 mt-1">Placering: {p.address}</p>
          </div>

        </div>
      </section>

      {/* Callout */}
      <section className="py-12 bg-white border-t border-[#1C1C1E]/10">
        <div className="max-w-7xl mx-auto px-4 text-center space-y-4">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1C1C1E] tracking-tight mb-4">{COMMON_CONTACT_CALLOUT.header}</h2>
          <p className="text-sm text-[#1C1C1E]/80 leading-relaxed">{COMMON_CONTACT_CALLOUT.p1}</p>
          <div className="pt-2 flex justify-center gap-4">
            <a href={COMPANY_INFO.phoneTel} className="bg-[#3885B8] hover:bg-[#2A6E9B] text-white px-5 py-2.5 rounded-full font-semibold text-sm whitespace-nowrap">
              Ring {COMPANY_INFO.phone}
            </a>
            <a href={COMPANY_INFO.emailMailto} className="border border-[#3885B8] text-[#3885B8] hover:bg-[#3885B8]/10 px-5 py-2.5 rounded-full font-semibold text-sm whitespace-nowrap">
              Skriv til os
            </a>
          </div>
        </div>
      </section>

      <GalleryModal
        images={p.images}
        isOpen={galleryOpen}
        initialIndex={galleryIndex}
        onClose={() => setGalleryOpen(false)}
      />
    </>
  );
}
